module.exports = __webpack_public_path__ + "img/charge_car0.b3b681a7.png";